import { useTranslation } from 'react-i18next'

import { ArrowsClockwise } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ChangeDeliveryMethodTitle = () => {
  const { t } = useTranslation()

  return (
    <Styles.ActionTitleContainer>
      <ArrowsClockwise size={16} />
      <Text type="bodyMRegular">{t('Cambiar método de devolución')}</Text>
    </Styles.ActionTitleContainer>
  )
}

export default ChangeDeliveryMethodTitle
